import type { History } from 'history'

import { getAbsoluteUrl } from './getAbsoluteUrl'

export const STRIPE_CHECKOUT_REDIRECT_PATH = '/stripe-redirect'
export const STRIPE_CHECKOUT_SESSION_ID_PLACEHOLDER = '{CHECKOUT_SESSION_ID}'

export type StripeCheckoutReturnFlow = 'payment_method_setup'

export const buildStripeCheckoutSuccessUrl = (flow: StripeCheckoutReturnFlow): string => {
  const redirectUrl = getAbsoluteUrl(STRIPE_CHECKOUT_REDIRECT_PATH)
  return `${redirectUrl}?session_id=${STRIPE_CHECKOUT_SESSION_ID_PLACEHOLDER}&flow=${flow}`
}

export const navigateToFrontendReturnUrl = (returnUrl: string, history: History): void => {
  const url = new URL(returnUrl)
  history.push(`${url.pathname}${url.search}${url.hash}`)
}
